<template>
  <div class="border border-gray-200 rounded-xl overflow-hidden">
    <div class="px-5 py-4 bg-gray-50 border-b border-gray-200">
      <h2 class="text-sm font-bold text-gray-900 flex items-center gap-2">
        <i class="pi pi-arrows-v text-primary"></i>
        Scrollbars
      </h2>
    </div>
    <div class="p-5 space-y-3">
      <p class="text-sm text-gray-600">
        Choose whether scrollbars stay visible for you across the portal. Your choice applies on this device
        and wins over the school setting.
      </p>
      <SelectButton
        v-model="choice"
        :options="options"
        optionLabel="label"
        optionValue="value"
        :allowEmpty="false"
        data-testid="scrollbar-preference"
      />
      <p class="text-xs text-gray-400">
        School default: scrollbars {{ schoolDefault ? 'visible' : 'hidden' }}.
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useScrollbarVisibility, type ScrollbarPreference } from '@/composables/useScrollbarVisibility';

const { schoolDefault, preference, setPreference } = useScrollbarVisibility();

// SelectButton needs a concrete value, so the "follow the school" state is a
// sentinel string mapped back to a null preference.
const options = [
  { label: 'School default', value: 'default' },
  { label: 'Always show', value: 'show' },
  { label: 'Always hide', value: 'hide' },
];

const choice = computed({
  get: () => preference.value ?? 'default',
  set: (value: string) => setPreference(value === 'default' ? null : (value as ScrollbarPreference)),
});
</script>
